module.exports = __webpack_public_path__ + "img/default_img_4.90472702.png";